import {useState} from "react";

export const useModalsReportTicketEvaluations = () => {

  const [visibleModalSearchAttendant, setVisibleModalSearchAttendant] = useState<boolean>(false);
  const [visibleModalSearchContacts, setVisibleModalSearchContacts] = useState<boolean>(false);

  return {
    visibleModalSearchAttendant, setVisibleModalSearchAttendant,
    visibleModalSearchContacts,setVisibleModalSearchContacts,
  }
}
